import React from 'react';

class ManipulateText extends React.Component {
	parse = (children) => {
	  const self = this;
	  let parsed = children;

	  if (typeof children === 'string') {
	    parsed = this.props.callback(children);
	  } else if (React.isValidElement(children)) {
	    parsed = React.cloneElement(
	      children,
	      {},
	      this.parse(children.props.children),
	    );
	  } else if (children instanceof Array) {
	    parsed = children.map(child => self.parse(child));
	  }

	  return parsed;
	};

	render() {
	  if (!this.props.callback) {
	    return (
  <div />
	    );
	  }
	  const parsedChildren = this.parse(this.props.children);

	  return (
  <div>
    {parsedChildren}
  </div>
	  );
	}
}

module.exports = ManipulateText;
